import TopBanner from "./TopBanner";
import Header from "./Header";
import Footer from "./Footer";
import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";

const GA_ID = "G-NGN819151V";

export default function Layout() {
  const { pathname, search, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      // Defer to allow the new route content to render before scrolling.
      const id = hash.slice(1);
      requestAnimationFrame(() => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        } else {
          window.scrollTo(0, 0);
        }
      });
    } else {
      window.scrollTo(0, 0);
    }
    if (typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        send_to: GA_ID,
        page_path: pathname + search,
        page_title: document.title,
        page_location: window.location.href,
      });
    }
  }, [pathname, search, hash]);
  return (
    <div className="App min-h-screen flex flex-col">
      <TopBanner />
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
